import { differenceInDays, parseISO } from 'date-fns';
import { Text } from '@qga/roo-ui/components';
import { getPendingScheduledPayment } from 'lib/bookingInfo';
import { DetailsBooking } from 'types';
import { FormattedDate } from 'components/Formatters';
import Timeline from 'components/Timeline';

interface Props {
  booking: DetailsBooking;
}

const ScheduledPaymentItem = ({ booking }: Props) => {
  if (!booking.flags.hasPendingScheduledPayment) {
    return null;
  }

  const scheduledPayment = getPendingScheduledPayment(booking)!;
  const daysBeforeCheckIn = differenceInDays(parseISO(booking.reservation.checkInDateTime), parseISO(scheduledPayment.deferredTo));
  const cardType = scheduledPayment.creditCardPaymentAllocation.paymentMethod.cardType;
  const lastFourDigits = scheduledPayment.creditCardPaymentAllocation.paymentMethod.lastFourDigits;
  const timeToCheckInDescription = `${daysBeforeCheckIn} day${daysBeforeCheckIn === 1 ? '' : 's'} before check-in`;

  return (
    <Timeline.Item
      iconColor="green"
      state="completed"
      title={<FormattedDate date={scheduledPayment.deferredTo} />}
      description={
        <>
          <Text as="div">{timeToCheckInDescription}</Text>
          <Text as="div">
            Final scheduled payment will be automatically charged to {cardType && `${cardType} `}credit card ending {lastFourDigits}.
          </Text>
          <Text as="div">Full refund</Text>
        </>
      }
    />
  );
};

export default ScheduledPaymentItem;
